import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import AuthenticatedRoute from './AuthenticatedRoute';

import role from '../../../services/ui/role';

const PlatformAdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (role.isPlatformAdmin(window.config.session_user)) {
                return (
                    <AuthenticatedRoute>
                        <Component {...props} />
                    </AuthenticatedRoute>
                );
            }

            return (
                <Redirect
                    to={{
                        pathname: '/',
                        state: { from: props.location },
                    }}
                />
            );
        }}
    />
);

export default PlatformAdminRoute;
